import React from "react";
import HeroSection from "../redesign/HeroSection";
import AboutSection from "../redesign/AboutSection";
import CapabilitiesSection from "../redesign/CapabilitiesSection";
import ProductOfferingsSection from "../redesign/ProductOfferingsSection";
import ValuesSection from "../redesign/ValuesSection";

export default function Home() {
  return (
    <div className="bg-[#F7F9FA] min-h-screen text-slate-800">
      <HeroSection />
      <AboutSection />
      <CapabilitiesSection />
      <ProductOfferingsSection />
      <ValuesSection />
    </div>
  );
}
